import React, {Component} from 'react'
import LayoutDashboard from "../../components/layout-dashboard";
import {connect} from "react-redux";
import LocalStorage from "../../util/localStorage";
import Resources from "../../data/services/resources";
import {classNames} from "../../util/util";
import {getSecondResource} from "../../data/actions/secondResource";
import SearchTab from "./searchTab";
import PageHeader from "../../components/layout-dashboard/page-header";

class RecruitingToolsPage extends Component {

    constructor(props) {
        super(props);

        const tabs = [
            {name: props.translate('tab.candidate_search'), resource: Resources.ClientContacts, current: true},
        ];

        this.state = {
            tabs: tabs,
            selectedTab: tabs[0].resource
        };
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        this.fetchData();
    };

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getSecondResource({
            user: LocalStorage.get("user"),
            query: {
                id: this.getId()
            },
            resource: Resources.Client
        }))
    };

    /** UI Events
     ================================================================= */
    handleTabChange = (resource) => {
        this.setState({
            tabs: this.state.tabs.map((it) => {
                it.current = it.resource === resource;
                return it;
            }),
            selectedTab: resource
        })
    };

    /** Helpers
     ================================================================= */
    getId = () => {
        return this.props.match.params && this.props.match.params.id;
    };

    /** Render
     ================================================================= */
    render() {
        const {translate} = this.props;

        return (
            <LayoutDashboard {...this.props}>
                <PageHeader
                    title={translate("page.title.search")}
                />

                <main className="pb-16 relative custom-min-h-page">
                    <div className="pt-8 pb-16 sm:px-6 lg:px-8 px-4">
                        <div className="px-4 sm:px-0">
                            {/* Tabs */}
                            <div className="sm:hidden">
                                <label htmlFor="tabs" className="sr-only">
                                    Select a tab
                                </label>

                                <select
                                    id="tabs"
                                    name="tabs"
                                    className="mt-4 block w-full pl-3 pr-10 py-2 text-base border-secondary-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md"
                                    defaultValue={this.state.tabs.find((tab) => tab.current).name}
                                    onChange={e => this.handleTabChange(e.target.value)}
                                >
                                    {this.state.tabs.map((tab) => (
                                        <option
                                            key={tab.name}
                                            value={tab.resource}
                                        >
                                            {tab.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="hidden sm:block">
                                <div className="border-b border-secondary-200">
                                    <nav className="mt-2 -mb-px flex space-x-8" aria-label="Tabs">
                                        {this.state.tabs.map((tab) => (
                                            <button
                                                key={tab.name}
                                                onClick={() => this.handleTabChange(tab.resource)}
                                                className={classNames(
                                                    tab.current
                                                        ? 'border-primary-500 text-primary-600'
                                                        : 'border-transparent text-secondary-500 hover:text-secondary-700 hover:border-secondary-200',
                                                    'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
                                                )}
                                            >
                                                {tab.name}
                                                {tab.count ? (
                                                    <span
                                                        className={classNames(
                                                            tab.current ? 'bg-primary-100 text-primary-600' : 'bg-secondary-100 text-secondary-900',
                                                            'hidden ml-2 py-0.5 px-2.5 rounded-full text-xs font-medium md:inline-block'
                                                        )}
                                                    >
                                                  {tab.count}
                                                </span>
                                                ) : null}
                                            </button>
                                        ))}
                                    </nav>
                                </div>
                            </div>

                        </div>

                        {/* Content */}
                        <div className="mt-1">
                            {this.state.selectedTab === Resources.ClientContacts && (
                                <SearchTab
                                    id={this.getId()}
                                    dispatch={this.props.dispatch}
                                    translate={this.props.translate}
                                    resource={this.props.resource}
                                />
                            )}
                        </div>
                    </div>
                </main>
            </LayoutDashboard>
        )
    }
}

export default connect(state => state)(RecruitingToolsPage);